module.exports = __webpack_public_path__ + "img/75_32.5adcc454.png";